import Head from "next/head";
import React, { FC } from "react";
import { DatoSeoTagFragment } from "services/datocms/generated";

const DatoHeadTagsRenderer: FC<{ datoSeoTag: DatoSeoTagFragment }> = ({
  datoSeoTag,
}) => {
  const seoFields = datoSeoTag?.mainSeoFields;

  return (
    <Head>
      <title>{seoFields?.title || ""}</title>
      <meta name="description" content={seoFields?.description || ""} />
      <meta
        name="robots"
        content={`${datoSeoTag?.robots?.index || ""}, ${
          datoSeoTag?.robots?.follow
        }, ${datoSeoTag?.robots?.["max-snippet"] || ""}, ${
          datoSeoTag?.robots?.["max-image-preview"] || ""
        }, ${datoSeoTag?.robots?.["max-video-preview"]}`}
      />
      <meta property="og:locale" content={"en_US"} />
      <meta property="og:title" content={seoFields?.title || ""} />
      <meta property="og:description" content={seoFields?.description || ""} />
      <meta property="og:site_name" content={"Rockstar Energy"} />
      {seoFields?.image?.url && (
        <meta property="og:image" content={seoFields?.image?.url || ""} />
      )}
      {seoFields?.image?.responsiveImage?.height && (
        <meta
          property="og:image:height"
          content={seoFields?.image?.responsiveImage?.height || "0"}
        />
      )}
      {seoFields?.image?.format && (
        <meta
          property="og:image:type"
          content={seoFields?.image?.format || "image/png"}
        />
      )}
      {seoFields?.twitterCard && (
        <meta name="twitter:card" content={seoFields?.twitterCard || ""} />
      )}
    </Head>
  );
};

export default DatoHeadTagsRenderer;
